import { render, staticRenderFns } from "./LoginLogo2.vue?vue&type=template&id=1b9bfd06&scoped=true"
import script from "./LoginLogo2.vue?vue&type=script&lang=js"
export * from "./LoginLogo2.vue?vue&type=script&lang=js"
import style0 from "./LoginLogo2.vue?vue&type=style&index=0&id=1b9bfd06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9bfd06",
  null
  
)

export default component.exports